module.exports = __webpack_public_path__ + "static/media/phone.0c0c3e1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/phone.svg
// module id = 1171
// module chunks = 0